import React, { ReactNode } from "react";

import * as PopOver from "@radix-ui/react-popover";

export const Popover: React.FC<{
  message: ReactNode | string;
  trigger: ReactNode;
  initialVisibility?: boolean;
}> = ({ message, trigger, initialVisibility = false }) => (
  <PopOver.Root defaultOpen={initialVisibility}>
    <div className="flex justify-center">
      <PopOver.Trigger asChild>{trigger}</PopOver.Trigger>
    </div>
    <PopOver.Content className="sid-popover__container" sideOffset={10} side="bottom">
      {message}
      <PopOver.Arrow className="sid-popover__caret" />
    </PopOver.Content>
  </PopOver.Root>
);
